import $ from 'jquery';

window.addEventListener( 'message', function( e ) {
	if ( e.data === '{"event":"NewsletterFormSubmit"}' || e.data === '{"event":"FormSubmit"}' ) {
		if ( $( '.js-form-title' ).length ) {
			$( '.js-form-title' ).addClass( 'u-hidden' ).removeClass( 'u-flex' );
		}
	}
} );
